import { z } from "zod";
export const PlaybookScriptItemSchema = z.object({
    id: z.string(),
    text: z.string(),
    completed: z.boolean(),
    completedAt: z.number().optional(),
    startedAt: z.number().optional(),
    partiallyCompleted: z.boolean().optional(),
    variant: z.enum(["script", "drill_down"]).optional(), // Eventually make this non-optional
});
export const PlaybookSectionSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: z.enum(["pending", "in_progress", "complete"]),
    startTime: z.number().optional(),
    endTime: z.number().optional(),
    successCriteria: z.string(),
    instructions: z.string(),
    startTranscriptId: z.string().optional(),
    endTranscriptId: z.string().optional(),
    scriptItems: z.array(PlaybookScriptItemSchema),
    currentScriptItemId: z.string().nullable(),
});
export const PlaybookProgressStatusSchema = z.enum([
    "pending",
    "in_progress",
    "complete",
]);
export const PlaybookProgressSchema = z.object({
    sections: z.array(PlaybookSectionSchema),
    currentSectionId: z.string().nullable(),
    currentScriptItemId: z.string().nullable().optional(),
    status: PlaybookProgressStatusSchema,
});
